// src/App.js
import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthProvider }  from "./context/AuthContext";
import { SiteProvider }  from "./context/SiteContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute    from "./admin/ProtectedRoute";
import ScrollToTop       from "./components/ScrollToTop";

import Home               from "./routes/Home";
import About              from "./routes/About";
import ResumePage from    "./routes/ResumePage";
import ProjectsPage       from "./routes/ProjectsPage";
import ProjectDetailPage  from "./routes/ProjectDetailPage";
import CertificationsPage from "./routes/CertificationsPage";
import CertificateDetailPage from "./routes/CertificateDetailPage";
import BlogPage           from "./routes/BlogPage";
import BlogPostPage       from "./routes/BlogPostPage";
import ContactPage        from "./routes/ContactPage";

import "./index.css";
import "./admin/AdminSettings.css"; // ← settings tab extra CSS

// Lazy: the admin subtree pulls in recharts, pdfjs-dist, and every admin
// tool (Resume/Blog/Presentation generators, Expenses) — none of that
// should ship in the bundle every public visitor downloads.
const AdminLogin     = lazy(() => import("./admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./admin/AdminDashboard"));

const AdminLoadingFallback = () => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-2)" }}>
    Loading…
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SiteProvider>
          <ScrollToTop />
          <Suspense fallback={<AdminLoadingFallback />}>
            <Routes>
              {/* Public */}
              <Route path="/"               element={<Home />}               />
              <Route path="/about"          element={<About />}              />
              <Route path="/resume"          element={<ResumePage />}              />
              <Route path="/projects"       element={<ProjectsPage />}       />
              <Route path="/projects/:id"   element={<ProjectDetailPage />}  />
              <Route path="/certifications" element={<CertificationsPage />} />
              <Route path="/certifications/:id" element={<CertificateDetailPage />} />
              <Route path="/blog"           element={<BlogPage />}           />
              <Route path="/blog/:slug"     element={<BlogPostPage />}       />
              <Route path="/contact"        element={<ContactPage />}        />

              {/* Admin */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Suspense>
        </SiteProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
